import { render } from "./HiddenErrorsTable.vue?vue&type=template&id=1588315c"
import script from "./HiddenErrorsTable.vue?vue&type=script&lang=ts"
export * from "./HiddenErrorsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script